<template>
  <a-row class="not-resize-for-mobile">
    <a-col :md="16" :sm="24" class="calc-permission-left">
      <a-card :bordered="false">
        <!-- 検索区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form
            @keyup.enter.native="searchQuery(false, false)"
            layout="inline"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-row :gutter="24">
              <a-col :sm="24" :md="12" :lg="10" :xl="7" :xxl="6">
                <a-form-item :label="this.$t('disp.depart')">
                  <j-input-popup
                    v-model="department"
                    component="SelectDepartTreeModal"
                    :placeholder="this.$t('disp.ph.select', [$t('disp.depart')])"
                    :params="{
                      companyId: '',
                      departName: '',
                      multiFlg: '0',
                      departFlg: '1',
                    }"
                    @change="deptChange"
                  ></j-input-popup>
                </a-form-item>
              </a-col>

              <a-col :sm="24" :md="12" :lg="10" :xl="7" :xxl="6">
                <a-form-item :label="this.$t('disp.position')">
                  <j-dict-select-tag
                    v-model="queryParam.positionId"
                    :placeholder="this.$t('disp.ph.select', [$t('disp.position')])"
                    dictCode="sys_position;name;id;del_flag = 0 order by post_rank asc,name asc"
                    :require="false"
                  />
                </a-form-item>
              </a-col>

              <a-col :sm="24" :md="12" :lg="10" :xl="7" :xxl="6">
                <a-form-item :label="this.$t('disp.role')">
                  <j-dict-select-tag
                    v-model="queryParam.roleId"
                    :placeholder="this.$t('disp.ph.select', [$t('disp.role')])"
                    dictCode="sys_role;role_name;id;del_flag = 0 order by role_name asc"
                    :require="false"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <div class="table-operator">
          <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
            $t('disp.btn.search')
          }}</a-button>

          <a-button @click="searchReset" icon="stop">
            {{ $t('disp.btn.reset') }}
          </a-button>

          <a-divider type="vertical"></a-divider>

          <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>

          <a-button @click="handleSpecialAuth" type="primary" icon="usergroup-add">{{
            $t('disp.specialAuth')
          }}</a-button>
        </div>

        <div class="ant-alert ant-alert-info div-selected-info">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>
          {{ this.$t('disp.selected') }}
          <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
          {{ this.$t('disp.item') }}
          <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
        </div>

        <div>
          <a-table
            ref="table"
            tableLayout="auto"
            class="action"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              type: 'radio',
            }"
            @change="handleTableChange"
          >
            <div slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
              <a-divider type="vertical" />
              <a @click="handleCopy(record)">{{ $t('disp.btn.copy') }}</a>
              <a-divider type="vertical" />
              <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDeleteDo(record)">
                <a>{{ $t('disp.btn.delete') }}</a>
              </a-popconfirm>
            </div>
          </a-table>
        </div>

        <!-- 特殊権限フォーム区域 -->
        <special-auth-modal ref="SpecialAuthModal"></special-auth-modal>

        <!-- フォーム区域 -->
        <permission-modal ref="modalForm" @ok="modalFormOk"></permission-modal>
      </a-card>
    </a-col>
    <a-col :md="8" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="$t('disp.menu')" key="1" :forceRender="true">
          <permission-Tree-modal ref="PermissionTreeModal"></permission-Tree-modal>
        </a-tab-pane>
      </a-tabs>
    </a-col>
  </a-row>
</template>
<script>
import { tableMixin } from '@/mixins/tableMixin'
import { deleteAction, postAction, getAction } from '@/api/manage'
import { filterObj } from '@/utils/util'
import moment from 'moment'
import PermissionModal from './modules/PermissionModal'
import SpecialAuthModal from './modules/SpecialAuthModal'
import PermissionTreeModal from './modules/PermissionTreeModal'
import JInputPopup from '@/components/JInputPopup'

export default {
  name: 'PermissionManage',
  mixins: [tableMixin],
  components: {
    JInputPopup,
    PermissionModal,
    SpecialAuthModal,
    PermissionTreeModal,
    moment,
  },
  mounted() {
    this.forceClear = true
  },
  data() {
    return {
      model: {},
      department: [],
      currentRoleId: '',
      labelCol: {
        xs: { span: 8 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 },
      },
      columns: [
        {
          title: this.$t('disp.groupPermissionName'),
          dataIndex: 'permissionName',
        },
        {
          title: this.$t('disp.depart'),
          dataIndex: 'departName',
        },
        {
          title: this.$t('disp.position'),
          dataIndex: 'positionName',
        },
        {
          title: this.$t('disp.role'),
          dataIndex: 'roleName',
        },
        {
          title: this.$t('disp.operation'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      queryParam: {
        departId: '',
        positionId: '',
        roleId: '',
      },
      url: {
        list: '/blaze-sys/k00/k0004/PermissionManage/list',
        delete: '/blaze-sys/k00/k0004/PermissionManage/delete',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleSpecialAuth() {
      this.$refs.SpecialAuthModal.open()
    },
    /**
     * @deprecated 検索エリア_担当部門の虫眼鏡クリック処理
     */
    deptChange() {
      this.$nextTick(() => {
        if (this.department.length > 0) {
          this.queryParam.departId = this.department[0].value
        } else {
          this.queryParam.departId = null
        }
      })
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows

      this.$refs.PermissionTreeModal.onClearSelected()
      this.$refs.PermissionTreeModal.open(selectionRows[0])
    },
    handleDeleteDo: function (record) {
      if (!this.url.delete) {
        this.$message.error(this.$t('disp.setUrlDelete'))
        return
      }
      var params = {}
      params.departId = record.departId
      params.positionId = record.positionId
      params.roleId = record.roleId
      params.permissionName = record.permissionName

      var that = this
      deleteAction(that.url.delete, params).then((res) => {
        if (res.success) {
          that.$message.success(that.$t(res.message))
          that.searchQuery(true, false)
        }
      })
    },
    handleCopy: function (record) {
      var params = {}
      params.departId = record.departId
      params.departName = record.departName
      params.positionId = record.positionId
      params.roleId = record.roleId
      params.permissionName = record.permissionName + '-拷贝'
      //コービーフラグを「１」に設定する
      params.openFlag = '1'
      this.$refs.modalForm.edit(params)
      this.$refs.modalForm.title = this.$t('disp.btn.copy')
      this.$refs.modalForm.disableSubmit = false
    },
    /**
     * @deprecated リセット
     */
    searchReset() {
      this.queryParam = {
        departId: '',
        positionId: '',
        roleId: '',
      }
      // 担当部門
      this.department = []
    },
  },
  watch: {
    selectedRowKeys: function (e) {
      if (this.selectedRowKeys.length == 0) {
        this.$refs.PermissionTreeModal.permissionName = ''
      }
    },
  },
}
</script>
<style scoped>
</style>
